.pagination-container {
  display: flex;
  align-items: center;

  .pagination-info {
    margin-right: 20px;
  }

  .pagination-size {
    margin-right: 10px;

    select {
      border: 1px solid rgba($color: #d4d4d4, $alpha: 1);
      outline: 0;
      padding: 4px 8px;
      border-radius: 5px;
    }
  }

  .pagination-page {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin: 4px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    background: transparent;

    &.active {
      background-color: var(--primary-main);
      color: #fff;
    }
  }

  .pagination-previous,
  .pagination-next {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px;
    border: none;
    cursor: pointer;
    background: transparent;

    &[disabled] {
      cursor: not-allowed;
    }
  }

  .pagination-go-to {
    span {
      margin-right: 10px;
    }

    input {
      border: 1px solid rgba($color: #d4d4d4, $alpha: 1);
      outline: 0;
      padding: 4px 8px;
      border-radius: 5px;
      text-align: center;
      width: 30px;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }
  }
}
